import ReactDOM from 'react-dom/client'
import './index.css'
import App from './App'
import reportWebVitals from './reportWebVitals'
import { BrowserRouter } from 'react-router-dom'
import React from 'react'
import { createStore, applyMiddleware } from 'redux'
import rootReducer from './modules'
import { Provider } from 'react-redux'
import thunkMiddleware from 'redux-thunk'
import ScrollToTop from './utils/scrollToTop'

import axios from 'axios'

const store = createStore(
  rootReducer,
  applyMiddleware(thunkMiddleware.withExtraArgument(axios))
)
const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter basename={process.env.PUBLIC_URL}>
        <ScrollToTop />

        <App />
      </BrowserRouter>
    </Provider>
  </React.StrictMode>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
